import { useEffect, useState } from "react";

import { getStorageValue } from "../../core/useLocalStorageForChat";
import useChatPopup from "../../hooks/useChatPopup";
import { ChatPopupHelper } from "../../mui-toolkit/chatPopup/ChatPopupHelper";
import ChatSidebar from "./ChatSidebar";
import { SettingsContentComponent } from "./SettingsContentComponent";

function ChatContent({
  chats,
  setChats,
  currentChatId,
  setCurrentChatId,
  systemPrompt,
  isSettingsOpen,
  setIsSettingsOpen,
}) {
  const { currentTranscript, listening, elapsedTime, handleStartRecording, handleStopRecording, promptName } =
    useChatPopup({ systemPrompt });

  // Check if we're in "new chat" mode (currentChatId is null)
  const isNewChat = currentChatId === null;

  const currentChat = isNewChat
    ? { messages: [], title: "" }
    : chats.find((chat) => chat.id === currentChatId) || { messages: [], title: "" };

  const TITLE_LENGTH = 70;
  const AUDIO_MODE_KEY = "tilley_audio_mode";
  const [audioMode, setAudioMode] = useState(getStorageValue(AUDIO_MODE_KEY, true));
  useEffect(() => {
    setAudioMode(getStorageValue(AUDIO_MODE_KEY, true));
  }, []);
  const handleAudioModeChange = (value) => {
    setAudioMode(value);
  };

  return (
    <>
      <div className="main">
        {isSettingsOpen ? (
          <SettingsContentComponent
            isTileyChat={false}
            onAudioModeChange={handleAudioModeChange}
            audioMode={audioMode}
          />
        ) : (
          <>
            {currentChat.messages.length > 0 && (
              <div className="main-header">
                {currentChat.title.length > TITLE_LENGTH
                  ? `${currentChat.title.slice(0, TITLE_LENGTH)}…`
                  : currentChat.title}
              </div>
            )}
            <ChatPopupHelper
              showPopup={true}
              chats={chats}
              setChats={setChats}
              currentChatId={currentChatId}
              setCurrentChatId={setCurrentChatId}
              isBigChatFlag={true}
              isNewChat={isNewChat}
              userMessage={currentTranscript}
              promptName={promptName}
              onStopRecording={handleStopRecording}
              onStartRecording={handleStartRecording}
              listening={listening}
              elapsedTime={elapsedTime}
            />
          </>
        )}
      </div>

      <ChatSidebar
        chats={chats}
        setChats={setChats}
        currentChatId={currentChatId}
        setCurrentChatId={setCurrentChatId}
        isSettingsOpen={isSettingsOpen}
        setIsSettingsOpen={setIsSettingsOpen}
      />
    </>
  );
}

export default ChatContent;
